<template>
  <div class="global-settings">
    <v-card class="card mt-5 pa-3" width="100%" max-width="600">
      <div>
        <div>
          <div class="setting-title mt-2">
            <div class="setting-text">
              <p class="subheading mb-0">Reset Standard Exercise Scores</p>
              <p class="body-1">
                Reset all saved standard exercise scores from all disciplines.
                (the exercises that are bundled with EarBeater).
              </p>
            </div>
            <v-spacer></v-spacer>
            <v-btn @click="showConfirmResetStandardScores = true" flat
              >Reset</v-btn
            >
          </div>
          <v-divider></v-divider>
        </div>

        <div>
          <div class="setting-title mt-3">
            <div class="setting-text">
              <p class="subheading mb-0">Reset Custom Exercise Scores</p>
              <p class="body-1">
                Reset all saved custom exercise scores from all disciplines.
                (The exercises you created yourself).
              </p>
            </div>
            <v-spacer></v-spacer>
            <v-btn @click="showConfirmResetUserScores = true" flat>Reset</v-btn>
          </div>
          <v-divider></v-divider>
        </div>

        <div>
          <div class="setting-title mt-3">
            <div class="setting-text">
              <p class="subheading mb-0">Delete Custom Exercises</p>
              <p class="body-1">Delete all your custom exercises.</p>
            </div>
            <v-spacer></v-spacer>
            <v-btn @click="showDeleteCustomExercises = true" flat>Delete</v-btn>
          </div>
        </div>
      </div>
      <!-- End Settings -->
    </v-card>

    <!-- Confirm reset standard scores -->

    <v-dialog v-model="showConfirmResetStandardScores" max-width="300px">
      <v-card>
        <v-card-title class="headline pb-0">Reset Scores?</v-card-title>
        <v-card-text
          >This will reset all your saved scores for the standard exercises. Are
          you sure you want to do this and start over?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal darken-1"
            flat
            @click="showConfirmResetStandardScores = false"
            >Cancel</v-btn
          >
          <v-btn color="red darken-1" flat @click="resetStandardScores"
            >Reset</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirm reset standard scores -->

    <v-dialog v-model="showConfirmResetUserScores" max-width="300px">
      <v-card>
        <v-card-title class="headline pb-0">Reset Scores?</v-card-title>
        <v-card-text
          >This will reset all your saved scores for your custom exercises. Are
          you sure you want to do this and start over?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal darken-1"
            flat
            @click="showConfirmResetUserScores = false"
            >Cancel</v-btn
          >
          <v-btn color="red darken-1" flat @click="resetUserScores"
            >Reset</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirm delete all user exercises-->

    <v-dialog v-model="showDeleteCustomExercises" max-width="300px">
      <v-card>
        <v-card-title class="headline pb-0"
          >Delete all your exercises?</v-card-title
        >
        <v-card-text
          >This action will delete all your custom created exercises. Are you
          sure you want to do this?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal darken-1"
            flat
            @click="showDeleteCustomExercises = false"
            >Cancel</v-btn
          >
          <v-btn color="red darken-1" flat @click="deleteUserExercises"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from "firebase/app";
import db from "@/firebase/init";
import emptyStandardExerciseScores from "../assets/data/emptyStandardExerciseScores.js";
export default {
  name: "globalSettings",
  data() {
    return {
      showConfirmResetStandardScores: false,
      showConfirmResetUserScores: false,
      showDeleteCustomExercises: false,
    };
  },
  methods: {
    resetStandardScores() {
      const uid = firebase.auth().currentUser.uid;

      db.collection("users")
        .doc(uid)
        .update({
          "standardExerciseScores": emptyStandardExerciseScores
        })
        .then(() => {
          this.showConfirmResetStandardScores = false;
          this.$store.dispatch('resetStandardScores', emptyStandardExerciseScores);
          this.$store.dispatch("setSnackbar", {
          timeout: 4000,
          text: "Your standard scores were wiped out!",
          });
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    resetUserScores() {
      const uid = firebase.auth().currentUser.uid;
      const finishedObject = {};
      db.runTransaction((t) => {
        const ref = db.collection("users").doc(uid);
        return t.get(ref).then((doc) => {
          const objectData = doc.data();
          // Pull out standardExerciseScores and save it in seperate variable
          const { standardExerciseScores, ...userExercises } = objectData;
          // Set the standard exercise scores on the object to return
          finishedObject.standardExerciseScores = standardExerciseScores;
          // Loop over user exercises and reset score
          for (let discipline in userExercises) {
            userExercises[discipline].forEach((exercise) => {
              exercise.score = 0;
            });
            finishedObject[discipline] = userExercises[discipline];
          }
          t.update(ref, finishedObject);
          // Reset in store
          this.$store.dispatch("resetUserScores", finishedObject);
        });
      })
        .then(() => {
          this.showConfirmResetUserScores = false;
          this.$store.dispatch("setSnackbar", {
            timeout: 4000,
            text: "Your custom scores were wiped out!",
          });
        })
        .catch((err) => {
          console.log("Transaction failed:", err.message);
        });
    },
    deleteUserExercises() {
      const uid = firebase.auth().currentUser.uid;

     db.collection("users").doc(uid).update({
       "userLevelsCompareIntervalSizes": [],
       "userLevelsIdentifyChordInversions": [],
       "userLevelsIdentifyChords": [],
       "userLevelsIdentifyIntervals": [],
       "userLevelsIdentifyScales": []
     }).then(() => {
       this.$store.dispatch("deleteUserExercises");
       this.showDeleteCustomExercises = false;
        this.$store.dispatch("setSnackbar", {
          timeout: 4000,
          text: "All your exercises were deleted.",
        });
     }).catch((err) => {
       console.log(err.message);
     });
      


      
    },
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style>
.global-settings {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.global-settings .profile-name-and-email {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.global-settings .setting-text {
  display: flex;
  flex-direction: column;
}
.global-settings .setting-title {
  display: flex;
}
</style>